import React, { Dispatch, SetStateAction, createContext, useState } from 'react';

interface FontSizeContextType {
    fontSize: string;
    setFontSize: Dispatch<SetStateAction<string>>;
  }


// Create a Context for the font size
const FontSizeContext = createContext<FontSizeContextType>({
    fontSize: 'sm',
    setFontSize: () => {},
  });

export const useFontSize = () => {
    return React.useContext(FontSizeContext);
  };


export const FontSizeProvider = (props:any) => {
  const [fontSize, setFontSize] = useState('sm');

  return (
    <FontSizeContext.Provider value={{ fontSize, setFontSize }}>
      {props.children}
    </FontSizeContext.Provider>
  );
};

